import { render, staticRenderFns } from "./add-category.vue?vue&type=template&id=f0dd3010"
import script from "./add-category.vue?vue&type=script&lang=js"
export * from "./add-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports